export class AdQRConfig {
  /** èæ¯ï¼é»è®¤ï¼`white` */
  background = 'white';
  /** èæ¯éæçº§å«ï¼èå´ï¼`0-1` ä¹é´ï¼é»è®¤ï¼`1.0` */
  backgroundAlpha = 1.0;
  /** åæ¯ï¼é»è®¤ï¼`black` */
  foreground = 'black';
  /** åæ¯éæçº§å«ï¼èå´ï¼`0-1` ä¹é´ï¼é»è®¤ï¼`1.0` */
  foregroundAlpha = 1.0;
  /** è¯¯å·®æ ¡æ­£çº§å«ï¼é»è®¤ï¼`L` */
  level: 'L' | 'M' | 'Q' | 'H' = 'L';
  /** äºç»´ç è¾åºå¾çMIMEç±»åï¼é»è®¤ï¼`image/png` */
  mime = 'image/png';
  /** åè¾¹è·ï¼åä½ï¼pxï¼ï¼é»è®¤ï¼`10` */
  padding = 10;
  /** å¤§å°ï¼åä½ï¼pxï¼ï¼é»è®¤ï¼`220` */
  size = 220;
}
